export const kGroupVirtualDocumentType = "GroupVirtualDocumentType";
/*
  NP/DL: 2019-10-15 -- GroupVirtualDocuments are simple objects that behave
  superficially like "Documents" in the workspace view.

  Unlike regular Documents, they do not store data, and are only used for teachers
  to monitor (read-only) student groups.

  This work helps teachers quickly switch between multiple compare views of
  different workgroups.

  See PT Stories:
  https://www.pivotaltracker.com/story/show/168619033
  https://www.pivotaltracker.com/story/show/168711827
*/
export class GroupVirtualDocument {
    constructor(group) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = group.id;
    }
    get type() {
        return kGroupVirtualDocumentType;
    }
    get key() {
        return `group-${this.id}`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3JvdXAtdmlydHVhbC1kb2N1bWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tb2RlbHMvZG9jdW1lbnQvZ3JvdXAtdmlydHVhbC1kb2N1bWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRywwQkFBMEIsQ0FBQztBQVVwRTs7Ozs7Ozs7Ozs7OztFQWFFO0FBQ0YsTUFBTSxPQUFPLG9CQUFvQjtJQUcvQixZQUFZLEtBQStDO1FBRjNDOzs7OztXQUFXO1FBR3pCLElBQUksQ0FBQyxFQUFFLEdBQUcsS0FBSyxDQUFDLEVBQUUsQ0FBQztJQUNyQixDQUFDO0lBRUQsSUFBSSxJQUFJO1FBQ04sT0FBTyx5QkFBeUIsQ0FBQztJQUNuQyxDQUFDO0lBRUQsSUFBSSxHQUFHO1FBQ0wsT0FBTyxTQUFTLElBQUksQ0FBQyxFQUFFLEVBQUUsQ0FBQztJQUM1QixDQUFDO0NBQ0YifQ==